(function ($) {
  'use strict'

  const ID_PATTERN = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/

  function youtubeId(url) {
    const match = String(url).trim().match(ID_PATTERN)
    return match && match[1]
  }

  $.extend(true, $.trumbowyg, {
    plugins: {
      youtube: {
        init: function (trumbowyg) {
          trumbowyg.addBtnDef('youtube', {
            title: 'Vídeo do YouTube',
            text: 'Vídeo',
            hasIcon: false,
            fn: function () {
              trumbowyg.saveRange()
              trumbowyg.openModalInsert('Vídeo do YouTube', {
                url: { label: 'Link do vídeo', required: true, attributes: { placeholder: 'https://www.youtube.com/watch?v=...' } },
                title: { label: 'Título (acessibilidade)', value: '' }
              }, function (values) {
                const id = youtubeId(values.url)
                if (!id) {
                  trumbowyg.addErrorOnModalField($('input[name=url]', trumbowyg.$box), 'Link do YouTube inválido')
                  return false
                }
                const iframe = $('<iframe>', {
                  src: `https://www.youtube-nocookie.com/embed/${id}`,
                  title: values.title || 'Vídeo do YouTube',
                  allow: 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
                  allowfullscreen: 'allowfullscreen',
                  loading: 'lazy',
                  frameborder: '0'
                })
                trumbowyg.restoreRange()
                trumbowyg.execCmd('insertHTML', $('<p>').append(iframe).prop('outerHTML') + '<p><br></p>')
                return true
              })
            }
          })
        }
      }
    }
  })
})(jQuery)
